function easterDate(y) {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100;
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(y, month - 1, day);
}

export const SEASONS = {
  christmas: {
    hero: "/hero/seasonal/christmas.jpg",
    label: "The Christmas Marketplace",
    headline: ["Christmas, sorted.", "All from one place."],
    sub: "Gifts from independent UK sellers, digital cards, instant vouchers and custom pet portraits — delivered in time, every time.",
    giftLabel: "Christmas gifting",
    giftHeading: "Last-minute? Instantly delivered 🎄",
    strip: "🎄 Christmas is coming — cards, gift vouchers and pet portraits arrive instantly, no postage needed.",
  },
  valentines: {
    hero: "/hero/seasonal/valentines.jpg",
    label: "Valentine's at MRQK",
    headline: ["Something special", "for someone special."],
    sub: "Valentine's gifts from independent UK sellers — plus instant vouchers, digital cards and custom portraits of the pet you both adore.",
    giftLabel: "Valentine's gifting",
    giftHeading: "Show them you thought about it ❤️",
    strip: "❤️ Valentine's Day is near — send a card, a voucher or a royal portrait of their beloved pet, instantly.",
  },
  mothers: {
    hero: "/hero/seasonal/mothers.jpg",
    label: "Mother's Day at MRQK",
    headline: ["For the woman who", "does everything."],
    sub: "Mother's Day gifts from independent UK sellers — beautiful finds, digital cards, instant vouchers and keepsake pet portraits.",
    giftLabel: "Mother's Day gifting",
    giftHeading: "Make her day 💐",
    strip: "💐 Mothering Sunday is coming — cards, vouchers and portraits she'll keep, delivered instantly.",
  },
};

export function currentSeason(now = new Date()) {
  const y = now.getFullYear();
  const md = (m, d) => new Date(y, m - 1, d);
  if (now >= md(11, 15) && now <= md(12, 26)) return "christmas";
  if (now >= md(1, 25) && now <= md(2, 14)) return "valentines";
  const easter = easterDate(y);
  const mothering = new Date(easter);
  mothering.setDate(easter.getDate() - 21);
  const start = new Date(mothering);
  start.setDate(mothering.getDate() - 20);
  if (now >= start && now <= mothering) return "mothers";
  return null;
}
